import { Button, Icon, Input, message, Modal } from 'antd'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { api } from '../../../../../../../../../services'
import actions from '../../../../../../../../../store/actions'
import nanoid from 'nanoid'
import { useTranslation } from 'react-i18next'

const WorldScenario = ({
  onCancel,
  extractedText,
  lessonTitle,
  pageStructureData,
  lessonUpdate,
  pages,
  currentPage,
  backgroundImageId = '',
  backgroundImageLink = '',
  backgroundImageOpacity = 0,
  backgroundColor = '',
  language
}) => {
  const [isGenerating, setIsGenerating] = useState(false)
  const [responseId, setResponseId] = useState('')
  const [userInstruction, setUserInstruction] = useState('')
  const [text, setText] = useState('')
  const { handleLessonInput } = actions.lessonBuilder

  const dispatch = useDispatch()

  const { t } = useTranslation()

  useEffect(() => {
    setText(extractedText)
  }, [extractedText])

  const startGeneration = () => {
    setIsGenerating(true)
    const currentPageData = pageStructureData[currentPage]
    const HeadingElement = currentPageData.data.find(
      item => item.type === 'TEXT' && item.display === 'HEADING'
    )
    const plainText = HeadingElement?.params?.content?.replace(
      /<\/?[^>]+(>|$)/g,
      ''
    )
    api.courses
      .generateWorldScenario({
        content: text,
        topic: lessonTitle || 'Real World Scenaio',
        subtopic: plainText,
        response_id: responseId,
        user_instruction: userInstruction,
        language
      })
      .then(res => {
        if (res?.data) {
          setResponseId(res.data?.response_id)
          setText(res.data?.scenario)
        }
      })
      .catch(err => {
        console.log(err)
      })
      .finally(() => {
        setIsGenerating(false)
      })
  }
  const addPage = () => {
    const currentPageData = pageStructureData[currentPage - 1]
    const logoItem = currentPageData.data.find(
      item => item.type === 'IMAGE' && item.display === 'LOGO'
    )
    const backgroundItem = backgroundImageId
      ? {
          uid: nanoid(8),
          type: 'BACKGROUND_IMAGE',
          params: {
            content: backgroundImageLink,
            content_id: backgroundImageId,
            opacity: backgroundImageOpacity
          }
        }
      : {
          uid: nanoid(8),
          type: 'BACKGROUND_COLOR',
          display: 'BACKGROUND_COLOR',
          params: {
            content: backgroundColor,
            content_id: null,
            opacity: 1
          }
        }

    const newPageData = {
      size: { width: 1024, height: 768 },
      orientation: 'landscape',
      data: [
        {
          uid: nanoid(8),
          type: 'TEXT',
          display: 'HEADING',
          params: {
            content: `<h1 class=\"ql-align-center\"><strong style=\"font-size: 36px;\">${t(
              'v4:real_world_scenario',
              { lng: language }
            )}</strong></h1>`,
            x: 57,
            y: 50,
            width: 900,
            height: 67,
            media_format: 'TEXT'
          }
        },
        {
          uid: nanoid(8),
          type: 'TEXT',
          display: 'CONTENT',
          params: {
            content: text,
            x: 57,
            y: 146,
            width: 900,
            height: 353
          }
        },
        backgroundItem,
        logoItem
      ].filter(Boolean)
    }

    const newPage = {
      data: [],
      orientation: 'portrait',
      size: { width: 1024, height: 768 }
    }

    const newData = [...pageStructureData]
    const newPages = [...pages]

    newData.push(newPageData)
    newPages.push(newPage)

    dispatch(handleLessonInput('pages_landscape', newData))
    dispatch(handleLessonInput('pages', newPages))
    dispatch(handleLessonInput('currentPage', currentPage))
    lessonUpdate({ pages_landScape: newData, pages: newPages })

    message.success('Real World Scenario added at the end of the lesson.')
    onCancel()
  }
  return (
    <Modal
      visible
      title={t('v4:real_world_scenario')}
      footer={null}
      onCancel={onCancel}
    >
      <Input.TextArea
        placeholder={t('v4:add_optional_instructions')}
        autoSize={{ minRows: 2, maxRows: 6 }}
        value={userInstruction}
        onChange={e => setUserInstruction(e.target.value)}
        style={{ marginBottom: '12px' }}
      />
      {responseId ? (
        <Input.TextArea
          autoSize={{ minRows: 8, maxRows: 20 }}
          value={text}
          onChange={e => setText(e.target.value)}
        />
      ) : (
        <div
          style={{
            padding: '20px',
            backgroundColor: '#f5f5f5',
            borderRadius: '8px',
            border: '1px dashed #d9d9d9',
            textAlign: 'center',
            color: '#666'
          }}
        >
          <Icon
            type="bulb"
            style={{ fontSize: '24px', marginBottom: '12px', color: '#1890ff' }}
          />
          <h4 style={{ margin: '0 0 8px 0', color: '#333' }}>
            {t('v4:ready_to_enerate_your_real_world_scenario')}
          </h4>
          <p style={{ margin: '0 0 12px 0', fontSize: '14px' }}>
            {t(
              'v4:click_generate_real_world_scenario_to_create_a_realistic_scenario'
            )}
          </p>
          <div style={{ fontSize: '12px', color: '#999' }}>
            <p style={{ margin: '4px 0' }}>
              • {t('v4:the_ai_will_analyze_your_lesson_topic_and_content')}
            </p>
            <p style={{ margin: '4px 0' }}>
              • {t('v4:generate_a_practical_real_world_scenario')}
            </p>
            <p style={{ margin: '4px 0' }}>
              • {t('v4:you_can_then_edit_and_customize_the_result')}
            </p>
            <p style={{ margin: '4px 0' }}>
              • {t('v4:add_it_as_a_new_page_to_your_lesson')}
            </p>
          </div>
        </div>
      )}
      {responseId ? (
        <div
          className="btn-group"
          style={{
            marginTop: '20px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <Button
            shape="round"
            onClick={() => startGeneration()}
            loading={isGenerating}
          >
            {t('v4:regenerate_with_instructions')}
            {!isGenerating && <Icon type="reload" style={{ marginLeft: 6 }} />}
          </Button>
          <Button
            type="primary"
            shape="round"
            icon="check"
            onClick={() => addPage()}
          >
            {t('v4:add_real_world_scenario')}
          </Button>
        </div>
      ) : (
        <div
          className="btn-group"
          style={{ marginTop: '20px', textAlign: 'center' }}
        >
          <Button
            type="primary"
            shape="round"
            onClick={() => startGeneration()}
            loading={isGenerating}
          >
            {t('v4:generate_real_world_scenario')}{' '}
            {!isGenerating && <Icon type="arrow-right" />}
          </Button>
        </div>
      )}
    </Modal>
  )
}

export default WorldScenario
